import {FC} from 'react';
import cx from 'classnames';
//mui
import {Box, StepConnector, StepConnectorProps, SxProps, Theme, Typography, useMediaQuery} from '@mui/material';
//constants
import {NUMBER} from '@/utils/constants';
//styles
import {stepperStyle} from './Stepper.styles';

interface StepperProps extends StepConnectorProps {
	activeStep: number;
	steps: string[] | number;
	sx?: SxProps<Theme>;
	parentClassName?: string;
}

const Stepper: FC<StepperProps> = ({steps, activeStep, parentClassName, sx, ...rest}) => {
	const isMobile = useMediaQuery('(max-width:639.98px)');

	const stepsArray = typeof steps === NUMBER ? Array.from({length: steps as number}) : (steps as string[]);
	const stepsToDisplay = isMobile ? [stepsArray[activeStep]] : stepsArray;

	return (
		<Box className={parentClassName} sx={{...sx, ...stepperStyle.wrapper}}>
			{stepsToDisplay.map((step, i) => (
				<Box key={i} sx={{...stepperStyle.step, ...(i > activeStep && stepperStyle.stepInactive)}}>
					{typeof steps !== NUMBER && <Typography sx={stepperStyle.stepTitle}>{step as string}</Typography>}

					<StepConnector
						{...rest}
						className={cx({
							'Mui-active': i === activeStep,
							'Mui-completed': i < activeStep,
						})}
					/>
				</Box>
			))}
		</Box>
	);
};

export default Stepper;
